import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useQuery } from "../../../utils/hooks";
import { useAppSelector } from "../../../Redux/hooks";
import { HeaderStyle } from "./ParticipantStyles";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { featuresMap } from "../../../utils/features";
import BackButton from "../../Common/UI/BackButton";

const TabsHeader = ({ setShowDownloadModal }: any) => {
  const { participantId, id: studyId } = useParams();
  const navigate = useNavigate();
  const participantName = useQuery().get("participant");
  const menuType = useAppSelector((state) => state.participantTab.menuType);
  const assignable = useAppSelector((state) => state.participantTab.assignable);
  const features = useAppSelector((state) => state.study.features);
  const isWearable = features?.[featuresMap.wearable];

  const handleBack = () => {
    navigate(-1);
  };
  const handlePrescriptionNavigate = () => {
    navigate(`/studies/${studyId}/participants/${participantId}/prescription`);
  };

  const toggleDownloadModal = async () => {
    setShowDownloadModal(true);
  };

  return (
    <Box sx={HeaderStyle}>
      <Stack
        direction="row"
        gap={1}
        alignItems={"center"}
        sx={{ height: "100%" }}
      >
        <BackButton onClick={handleBack} />
        <Typography variant="h2" color="text.primary">
          Participant ID: {participantName ?? participantId} Details
        </Typography>
        {menuType === "medication" && assignable && (
          <Box sx={{ ml: "auto" }} onClick={handlePrescriptionNavigate}>
            <Button variant="contained">Prescribe Medication</Button>
          </Box>
        )}
        {menuType === "participant_information" && isWearable && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="outlined"
              startIcon={<CloudDownloadIcon />}
              onClick={toggleDownloadModal}
            >
              Export
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default TabsHeader;
